/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component, Input} from '@angular/core';

/**
 * Component that displays a loading spinner on top of its content when the passed loading property is true.
 */
@Component({
  selector: 'gp-loading, [gp-loading]',
  template: `
    <div [ngClass]="{'element-loading': loading}">
      <div class="spinner" *ngIf="loading">
        <span class="gp-spinner gp-spinner--primary"></span>
      </div>
      <div class="element-content">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent {
  @Input('gp-loading')
  public loading: boolean = false;
}
